import { render } from "./TargetView.vue?vue&type=template&id=18c87753"
import script from "./TargetView.vue?vue&type=script&lang=js"
export * from "./TargetView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__